var render = function render(_c,_vm){return (_vm.props.value)?_c('div',{staticClass:"array-field__item"},[_c('div',{staticClass:"array-field__ellipsis",attrs:{"title":_vm.props.value}},[_vm._v("\n    "+_vm._s(_vm.props.value)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }